/**
 * Cross-tab "the library changed" signal. One channel per namespace; the
 * payload carries nothing, the receiver refetches the library record.
 */
import type { ExpressionNamespace } from '@/features/sliced-form/schemas/expression'

export type ExpressionsBroadcastMessage = { type: 'templates:updated' }

export interface ExpressionsBroadcastBinding {
  post: () => void
  close: () => void
}

export interface OpenExpressionsBroadcastOptions {
  namespace: ExpressionNamespace
  onTemplatesUpdated: () => void
}

export function openExpressionsBroadcast(
  opts: OpenExpressionsBroadcastOptions,
): ExpressionsBroadcastBinding {
  if (typeof BroadcastChannel === 'undefined') {
    return { post: () => {}, close: () => {} }
  }
  const channel = new BroadcastChannel(channelName(opts.namespace))
  channel.onmessage = (event: MessageEvent<ExpressionsBroadcastMessage>) => {
    if (event.data?.type === 'templates:updated') opts.onTemplatesUpdated()
  }
  return {
    post: () => {
      try {
        channel.postMessage({ type: 'templates:updated' } satisfies ExpressionsBroadcastMessage)
      } catch {
        /* a closed channel is not an error for the writer */
      }
    },
    close: () => {
      try {
        channel.close()
      } catch {
        /* swallow */
      }
    },
  }
}

export function channelName(namespace: ExpressionNamespace): string {
  return `edge-expressions:${namespace}`
}
